import { render, staticRenderFns } from "./ImportPaquetes2.vue?vue&type=template&id=fe2cd552&scoped=true"
import script from "./ImportPaquetes2.vue?vue&type=script&lang=js"
export * from "./ImportPaquetes2.vue?vue&type=script&lang=js"
import style0 from "./ImportPaquetes2.vue?vue&type=style&index=0&id=fe2cd552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2cd552",
  null
  
)

export default component.exports